exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".similar-scores.empty{background-color:#e2dee6}.similar-scores.low{background-color:#ec5e44}.similar-scores.low-med{background-color:#f38259}.similar-scores.med{background-color:#f9a66d}.similar-scores.med-high{background-color:#98b480}.similar-scores.high{background-color:#57be8c}.similar-spectrum{display:flex;font-size:12px}.similar-spectrum-box{border-radius:2px;margin:5px;width:14px}.similar-spectrum-box.empty{background-color:#e2dee6}.similar-spectrum-box.low{background-color:#ec5e44}.similar-spectrum-box.low-med{background-color:#f38259}.similar-spectrum-box.med{background-color:#f9a66d}.similar-spectrum-box.med-high{background-color:#98b480}.similar-spectrum-box.high{background-color:#57be8c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /usr/src/sentry/node_modules/css-loader?{"minimize":true}!/usr/src/sentry/node_modules/less-loader/dist/cjs.js!./less/components/similarSpectrum.less
// module id = 1142
// module chunks = 74